export default __webpack_public_path__ + "static/media/LooLeeBear_01.acc02626.jpg";